/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { checkedFields, defaultValueNa, defaultValueZero } from "../../../Constant";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";
import { Button, ThemeActionButton } from "../../widgets";
import { GenericLoaderComponent } from "../../widgets/genericLoader";
import { SortingView } from "../../widgets/sortingView/sortingView";
import "./tableWrapper.css";
// import { reportTypesEnum } from "../../../views/Dashboard/reports/reports-module/ReportsModule";

class TableWrapper extends React.PureComponent {
  handleClick = (event, vehicle) => {
    const {
      selected, markOption, content, selectionID, handleChange,
    } = this.props;
    const selectedIndex = selected.indexOf(vehicle);
    let newSelected = [];
    const stateDataArray = selected;
    if (selectedIndex === -1) {
      if (markOption && content) selectionID("selected", vehicle);
      newSelected = newSelected.concat(selected, vehicle);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        stateDataArray.slice(0, selectedIndex),
        stateDataArray.slice(selectedIndex + 1),
      );
    }
    if (selectedIndex !== -1 && markOption) selectionID("removed", vehicle);
    handleChange("selected", newSelected);
  };

  handleSelectAllClick = (event) => {
    const {
      uniqueKey, markOption, content, selectionID, handleChange,
    } = this.props;
    if (event.target.checked && content) {
      if (markOption) selectionID("all");
      const newSelecteds = content.map((n) => n[uniqueKey]);
      handleChange("selected", newSelecteds);
      return;
    }
    if (markOption) selectionID("clear");
    handleChange("selected", []);
  };

  handleSort(value, columnKey) {
    const { onSortToggle } = this.props;
    onSortToggle(value, columnKey);
  }

  isSelected = (name) => {
    const { selected } = this.props;
    return selected?.indexOf(name) !== -1;
  };

  // eslint-disable-next-line class-methods-use-this
  TablePaginationActions = (props) => {
    const {
      count, page, rowsPerPage, onChangePage,
    } = props;

    const handleFirstPageButtonClick = (event) => {
      onChangePage(event, 0);
    };

    const handleNextButtonClick = (event) => {
      onChangePage(event, page + 1);
    };

    const handleBackButtonClick = (event) => {
      onChangePage(event, page - 1);
    };

    const handleLastPageButtonClick = (event) => {
      onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className="paginationButtonWrapper">
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
          <FirstPageIcon />
          {" "}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          <LastPageIcon />
        </IconButton>
      </div>
    );
  };

  clearSelectedItem() {
    const { markOption, selectionID, handleChange } = this.props;
    if (markOption) selectionID("clear");
    handleChange("selected", []);
  }

  // eslint-disable-next-line class-methods-use-this
  shouldRenderColumnContent(
    templateString,
    column,
    row,
  ) {
    return (!templateString[column].component && (column === "action" || column === "storageKey" || (column === "detail" && (row.status === "Expired" || row.itemType?.toLowerCase() === "due" || row.itemType?.toLowerCase() === "operatorpayment"))));
  }

  // eslint-disable-next-line class-methods-use-this
  storageColumnContent(row, defaultVal) {
    if (row.status === "inProgress") {
      return <Typography style={{ color: "#FFBA00" }}>Generating...</Typography>;
    }
    if (row.status === "queued") {
      return <Typography style={{ color: "#FFBA00" }}>Request Sent.</Typography>;
    }
    if (row.status === "failed") {
      return <Typography style={{ color: "#FF0000" }}>Failed</Typography>;
    }
    return defaultVal;
  }

  // eslint-disable-next-line class-methods-use-this
  isDateColumn(templateString, column) {
    return (column === "fromDate" || column === "toDate" || column === "paymentDate" || column === "issuedDate" || column === "rechargeDate" || column === "generatedAt" || column === "ledgerDate" || column === "createdAt") && !templateString[column].do_not_convert_date;
  }

  // eslint-disable-next-line class-methods-use-this
  formatColumnDate(row, column) {
    let val;
    if ((column === "generatedAt" || column === "ledgerDate" || column === "createdAt")) {
      val = row[column] ? moment(row[column]).format("DD MMM YYYY, hh:mm A") : "-";
    } else if (column === "fromDate" || column === "toDate" || column === "paymentDate" || column === "issuedDate" || column === "rechargeDate") {
      val = row[column] ? moment(row[column]).format("DD MMM YYYY") : "";
    }
    return val;
  }

  // eslint-disable-next-line class-methods-use-this
  hasColumnTemplate(row, column, templateString) {
    return (row[column] && (templateString[column]?.is_encrypt
      || templateString[column]?.is_capital
      || templateString[column]?.is_all_capital));
  }

  // eslint-disable-next-line class-methods-use-this
  formatColumnValue(row, column, templateString) {
    let val;
    if (templateString[column]?.is_encrypt) {
      val = row[column].toString().replace(/\d(?=\d{4})/g, "*");
    } else if (templateString[column]?.is_capital) {
      val = row[column].toString().replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    } else if (templateString[column]?.is_all_capital) {
      val = row[column].toString().replace(/\w\S*/g, (txt) => txt.toUpperCase());
    }
    return val;
  }

  // eslint-disable-next-line class-methods-use-this
  shouldUseDefault(templateString, row, column) {
    return (!row[column] && templateString[column]
      && (defaultValueZero[column] || defaultValueNa[column]));
  }

  // eslint-disable-next-line class-methods-use-this
  defaultColumnValue(column) {
    if (defaultValueZero[column]) {
      return "0";
    }
    return "N/A";
  }

  // eslint-disable-next-line class-methods-use-this
  renderContent(args) {
    const {
      templateString,
      column,
      row,
      actionName,
      handleAction,
      handleSettlement,
      getWaitStatus,
      getDisabledStatus,
      reportTypesEnum,
    } = args;
    let result = templateString[column]?.defaultValue;
    if (this.shouldRenderColumnContent(
      templateString,
      column,
      row,
    )) {
      result = (
        <ThemeActionButton
          wait={getWaitStatus(row)}
          disabled={getDisabledStatus(row)}
          onClick={(event) => {
            event.stopPropagation();
            handleAction(row);
          }}
          buttonText={actionName || (row.itemType?.toLowerCase() === "operatorpayment" ? "Edit" : "Details")}
        />
      );
      if (column === "storageKey") {
        result = this.storageColumnContent(row, result);
      }
    } else if (column === "settleUnused") {
      result = (
        <ThemeActionButton
          onClick={(event) => {
            event.stopPropagation();
            handleSettlement(row);
          }}
          buttonText={actionName || "Settle unused tickets"}
        />
      );
    } else if (column === "reportType") {
      result = reportTypesEnum[row[column]]?.toString();
    } else if (column === "moneyLoaded") {
      result = (row.moneyLoaded + row.cardFeeCash).toLocaleString(
        undefined,
        { maximumFractionDigits: 2 },
      );
    } else if ((this.isDateColumn(templateString, column))) {
      result = this.formatColumnDate(row, column);
    } else if (this.hasColumnTemplate(row, column, templateString)) {
      result = this.formatColumnValue(row, column, templateString);
    } else if ((row[column] || row[column] === 0)) {
      result = row[column].toLocaleString(undefined, { maximumFractionDigits: 2 });
    } else if (this.shouldUseDefault(templateString, row, column)) {
      result = this.defaultColumnValue(column);
    }
    return result;
  }

  // eslint-disable-next-line class-methods-use-this
  renderNestedContent(templateString, column, row) {
    if (templateString[column].children && row[column]) {
      const nestedObject = templateString[column]?.children;
      return Object.keys(nestedObject).map((key) => (
        <div className="grey-hash-text" key={key}>
          {nestedObject[key].displayName}
          {row[key] || nestedObject[key].defaultValue || ""}
        </div>
      ));
    }
    return null;
  }

  // eslint-disable-next-line class-methods-use-this
  renderLiveStatusContent(
    checkLiveNoLive,
    gridLoader,
    handleMarkClick,
    selected,
  ) {
    let val;
    const liveStatus = checkLiveNoLive();
    // if (liveStatus === false) {
    //   val = (
    //     <Button
    //       classname="markBtn"
    //       disable={!!gridLoader}
    //       onClick={() => {
    //         handleMarkClick("Live", selected);
    //       }}
    //       buttonText="Contract applied"
    //     />
    //   );
    // } else
    if (liveStatus === true) {
      val = (
        <Button
          classname="markBtn"
          disable={!!gridLoader}
          onClick={() => {
            handleMarkClick("No Live", selected);
          }}
          buttonText="Edit Contract"
        />
      );
    } else if (liveStatus === "error") {
      val = (
        <div style={{ color: "red" }}>{checkedFields.multiple_type_checked}</div>
      );
    } else if (liveStatus === "multiple_live") {
      val = (
        <div style={{ color: "red" }}>{checkedFields.select_only_one_live}</div>
      );
    } else if (liveStatus === "running_waybill") {
      val = (
        <div style={{ color: "red" }}>{checkedFields.edit_contracts_running_waybill}</div>
      );
    }
    return val;
  }

  renderTableHead(selectionAllowed, selected, content, templateString, sortBy, minWidth) {
    return (
      <TableRow>
        {selectionAllowed && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={
                selected.length > 0 && selected.length < content.length
              }
              checked={
                content.length > 0 && selected.length === content.length
              }
              onChange={this.handleSelectAllClick}
              inputProps={{ "aria-label": "select all desserts" }}
            />
          </TableCell>
        )}
        {Object.keys(templateString).map((columnKey) => (
          <TableCell style={{ minWidth: minWidth || 130 }} key={columnKey}>
            {templateString[columnKey].displayName
              ? templateString[columnKey].displayName
              : templateString[columnKey]}
            {templateString[columnKey].sortable && (
              <SortingView
                onToggle={(value) => this.handleSort(value, columnKey)}
                columnKey={columnKey}
                sortBy={sortBy}
              />
            )}
          </TableCell>
        ))}
      </TableRow>
    );
  }

  render() {
    const {
      gridLoader, selected, selectionAllowed,
      markOption, removePagination, count,
      rowsPerPage, pageNo,
      paperClassName, tableContainerClassName,
      reportTypesEnum, checkLiveNoLive,
      handleMarkClick, content, templateString,
      minWidth, sortBy, uniqueKey, getWaitStatus,
      getDisabledStatus, handleAction, actionName,
      handleSettlement, handleChange,
    } = this.props;
    return (
      <div>
        <Paper className={`customTable ${paperClassName || ""}`}>
          {gridLoader ? <GenericLoaderComponent absolute /> : ""}
          {selectionAllowed && selected.length > 0 && (
            <Toolbar className="enhancedToolBar">
              <Typography color="inherit" variant="subtitle1" component="div">
                {selected.length}
                {" "}
                selected
              </Typography>
              <div
                role="button"
                className="clearDiv"
                onClick={this.clearSelectedItem.bind(this)}
                tabIndex="0"
                onKeyDown={
                  (event) => event.key === "Enter" && this.clearSelectedItem()
                }
              >
                <span>Clear</span>
              </div>
              {markOption && (
                <div>
                  {this.renderLiveStatusContent(
                    checkLiveNoLive,
                    gridLoader,
                    handleMarkClick,
                    selected,
                  )}
                </div>
              )}
            </Toolbar>
          )}
          <TableContainer className={tableContainerClassName || ""}>
            <Table stickyHeader>
              <TableHead className="tableHeader">
                {this.renderTableHead(
                  selectionAllowed,
                  selected,
                  content,
                  templateString,
                  sortBy,
                  minWidth,
                )}
              </TableHead>
              <TableBody>
                {content.length > 0
                  && content.map((row, index) => {
                    const isItemSelected = this.isSelected(row[uniqueKey]);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        key={row[uniqueKey]}
                        role="checkbox"
                        hover
                        onClick={
                          selectionAllowed
                            ? (event) => this.handleClick(event, row[uniqueKey])
                            : null
                        }
                        tabIndex={-1}
                        aria-checked={isItemSelected}
                        selected={isItemSelected}
                      >
                        {selectionAllowed && (
                          <TableCell padding="checkbox">
                            <Checkbox checked={isItemSelected} inputProps={{ "aria-labelledby": labelId }} />
                          </TableCell>
                        )}
                        {Object.keys(templateString).map((column, idx) => (
                          <TableCell key={idx}>
                            {!!templateString[column].component && (
                              templateString[column].component(row)
                            )}
                            {this.renderContent(
                              {
                                templateString,
                                column,
                                row,
                                actionName,
                                handleAction,
                                handleSettlement,
                                getWaitStatus,
                                getDisabledStatus,
                                reportTypesEnum,
                              },
                            )}
                            {this.renderNestedContent(templateString, column, row)}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="pagination-icons">
            {this.props && !removePagination && (
              <TablePagination
                colSpan={3}
                component="div"
                count={count}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 75, 100]}
                onChangeRowsPerPage={(event) => {
                  handleChange("rowsPerPage", +event.target.value);
                  handleChange("pageNo", 0);
                }}
                page={pageNo}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                }}
                onChangePage={(event, newpage) => handleChange("pageNo", newpage)}
                ActionsComponent={this.TablePaginationActions}
              />
            )}
          </div>
        </Paper>
      </div>
    );
  }
}

TableWrapper.defaultProps = {
  getDisabledStatus: () => { },
  getWaitStatus: () => { },
};

function mapStateToProps(state) {
  return {
    gridLoader: (state && state.loadingBar && state.loadingBar.gridLoader),
    reportTypesEnum: (state && state.GenerateReports && state.GenerateReports.reportTypes),
  };
}

const mapDispatchToProps = (dispatch) => ({
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TableWrapper);
